const withdrawChargePercentage = 5;
export const withdrawCharge = (amount) => Number(amount - (amount/100)*5).toFixed(2)
